import {
  AchPaymentMethod,
  CreditCardPaymentMethod,
} from "@covertree/agent-portal-graphql";

type PaymentMethodType = CreditCardPaymentMethod | AchPaymentMethod;

export function isCreditCardPaymentMethod(
  method: PaymentMethodType
): method is CreditCardPaymentMethod {
  return "brand" in method;
}

export const mapAchPaymentMethodName = (ach: AchPaymentMethod): string =>
  `Bank Account ${ach.bankName} **** ${ach.last4Digits}`;

export const mapCreditCardPaymentMethodName = (
  card: CreditCardPaymentMethod
): string => `Credit Card ${card.brand.toUpperCase()} **** ${card.last4Digits}`;

export const mapCreditCardPaymentMethodExpiration = (
  card: CreditCardPaymentMethod
): string =>
  `Expires on ${String(card.expiration.month).padStart(2, "0")}/${
    card.expiration.year
  }`;

export const isCreditCardExpired = (card: CreditCardPaymentMethod): boolean => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  const { month, year } = card.expiration;

  return year < currentYear || (year === currentYear && month < currentMonth);
};
